<template>
    <button class="button" @click="handleOrderPopup">
        <p class="single-button-text">Заказать</p>
        <i class="fas fa-shopping-cart"></i>
    </button>
</template>
<script setup>
    import {ref, defineProps, onMounted} from 'vue';
    const props = defineProps(['product']);
    import { useStore } from 'vuex';
    const store = useStore();
    const openByProduct = ref(null);
    function handleOrderPopup() {
        store.commit('TOGGLE_ORDER_POPUP', props.product)
    }
</script>
<style setup>
.singleProduct{
    margin-top: 120px;
    color: #3c5757;
    @media screen and (max-width:500px) {
        margin-top: 145px;
    }
}
.single-block{
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px
}
/* .singleProduct-name-block {
    width: 100%;
    display: flex;
    gap: 15px;
    justify-content: flex-start;
    align-items: center;
} */
/* .singleProduct-name {
    text-transform: uppercase;
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 35px;
} */
.single-product-img-info-block {
    width: 100%;
    display: flex;
    gap: 15px;
}
.single-product-img {
    width: 50%;
    height: auto;
    border-radius: 8px;
    overflow: hidden;
}
.single-product-info-right {
    width: 50%;
    display: flex;
    flex-direction: column;
}
.button {
    width: 150px;
    height: 46px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    background-color: #e8cc0f;
    gap: 8px;
    margin: 20px 0 30px 0;
    &:hover {
        background-color: #3c5757;
        color:#e8cc0f
    }
}
.single-button-text {
    font-size: 20px;
}
.product-code-block {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-bottom: 20px;
    font-size: 20px;
    
    padding-bottom: 10px;
}
@media screen and (max-width: 768px) {
        .single-product-img-info-block {
            flex-direction: column;
        }
        .single-product-img {
            width: 100%;
        }
        .single-product-info-right {
            width: 100%;
        }
        /* .singleProduct-name-block {
            justify-content: center;
        } */
        .button{
            align-self: center;
        }
    }
    .singlePopap {
    width: 100%;
    height: 100%;
    position: fixed;
    padding: 30px 0;
    top: 0;
    left:0;
    z-index: 100000;
    background-color:rgba(60, 87, 87, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    @media screen and (max-width: 620px) {
        
    }
   
}
.singlePopap {
  color:#3c5757
}
.single-block-popup{
    overflow-x: auto;
  width: 60%;
  height: 620px;
  background-color: white;
    padding: 30px;
    border-radius: 10px;
}
.close-block {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 30px;
}
.popup-text {
  font-size: 20px;
    margin-bottom: 20px
}
.close {
  font-size: 25px;
}
.popup-contact {
  padding-left: 0 !important;
}
@media screen and (max-width: 770px) {
  .single-block-popup{
    width: 95%;
  }
}
</style>